export default "/images/vendor/flag-icons/flags/4x3/tw.svg?39308d8769d9190bd1aaa8ff1a6a5f88";